import { Input } from "./ui/input";
import { Label } from "./ui/label";

export default function UnitPricesInput({ items, unitPrices, setUnitPrices, setTotal }) {
  const vals = items.map((_, i) => unitPrices?.[i] ?? "");
  const update = (i, v) => {
    const next = [...vals]; next[i] = v;
    setUnitPrices(next);
    if (next.every(x => x !== "" && Number(x) > 0)) {
      setTotal(items.reduce((s, it, j) => s + Number(it.quantity || 0) * Number(next[j]), 0).toFixed(2));
    }
  };
  return (
    <div data-testid="unit-prices-block">
      <Label>Prezzo per unità (opzionale)</Label>
      <div className="mt-1 space-y-1.5">
        {items.map((it, i) => (
          <div key={i} className="grid grid-cols-12 gap-2 items-center text-sm">
            <div className="col-span-6 truncate text-slate-700">{it.name} <span className="text-slate-400 font-mono text-xs">× {it.quantity} {it.unit}</span></div>
            <div className="col-span-6 flex items-center gap-1">
              <span className="text-xs text-slate-500">€</span>
              <Input type="number" step="0.01" min="0" value={vals[i]} onChange={e => update(i, e.target.value)} placeholder={`/${it.unit}`} className="h-8" data-testid={`unit-price-${i}`} />
              <span className="text-xs text-slate-500 whitespace-nowrap">/{it.unit}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="text-[11px] text-slate-500 mt-1">Compilando tutti i prezzi unitari il totale si calcola da solo. L'asta confronta sempre il prezzo totale.</div>
    </div>
  );
}
